import { render, staticRenderFns } from "./payment-status-details.vue?vue&type=template&id=0bf85cef"
import script from "./payment-status-details.vue?vue&type=script&lang=js"
export * from "./payment-status-details.vue?vue&type=script&lang=js"
import style0 from "./payment-status-details.vue?vue&type=style&index=0&id=0bf85cef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports